<template>
  <div class="container">
    <div class='reload'>
      <el-breadcrumb separator="/">
        <span class="leftLine"></span>
        <el-breadcrumb-item>客户电力交易结算</el-breadcrumb-item>
        <el-breadcrumb-item>查看</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-arrow-left"
                 size="mini"
                 @click="$router.back()">返回</el-button>
    </div>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="formBox">
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   label-position="left"
                   :rules="rules"
                   style="padding:20px;background:#fff"
                   label-width="180px">
            <el-row :gutter="60">
              <el-col :span="12">
                <el-form-item label="结算日期："
                              prop="balancedate">
                  {{form.balancedate}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="考核执行偏差：">
                  {{form.assess}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户名称：">
                  {{form.customername}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="偏差考核费用：">
                  {{form.deviation}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区域："
                              prop="areaName">
                  {{form.areaName}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="用户偏差考核费用：">
                  {{form.userfees}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="交易电量(kW·h)："
                              required>
                  {{form.electric}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="代理售电公司考核费用：">
                  {{form.companyexpense}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label=" 实际用电量(kW·h)：" prop="practical">
                  {{form.practical}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="优惠金额：">
                  {{form.discount}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="偏差电量(kW·h)：">
                  {{form.power}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="合计优惠金额：">
                  {{form.totaldiscount}}
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="偏差率：">
                  {{form.deviationratio}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="允许偏差电量：(kWh)">
                  {{form.bias}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售提成">
                  {{form.salesCommissions}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  {{form.remake}}
                </el-form-item>
              </el-col>

            </el-row>
            <div class="ax_default line1"></div>
            <el-form-item>
              <div style="text-align:center">
                <el-button @click="$router.back()">返回</el-button>
              </div>

            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postQueryDeal, putQueryDeal, getQueryDealOne, getprovince } from '../../API'
export default {
  data () {
    return {
      activeIndex: this.$route.path,
      name: '新增',
      form: {
        area: '',
        assess: '',
        balancedate: '',
        bias: '',
        salesCommissions: '',
        companyexpense: '',
        customername: '',
        deviation: '',
        deviationratio: '',
        discount: '',
        electric: '',
        electro: '',
        id: '',
        power: '',
        practical: '',
        region: '',
        remake: '',
        totaldiscount: '',
        userfees: '',
        userid: '',
      },
      rules: {
        area: { required: true, message: '必填', trigger: 'change' },
        practical:{ required: true, message: '必填', trigger: 'blur' },
         balancedate:{ required: true, message: '必填', trigger: 'blur' },
      },
      provinces: []
    }
  },
  created () {
    if (localStorage.getItem('dljyid') !== null) {
      this.name = '修改'
      getQueryDealOne(localStorage.getItem('dljyid')).then(res => {
        if (res.code == 0) {
          this.form = res.data
        }
      })
    }
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinces = res.data
      }
    })
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('dljyid')) {
            this.form.areaName = _.find(this.provinces, { code: this.form.area }).name
            putQueryDeal(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                     let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })

          }
          else {
            this.form.customerid = localStorage.getItem('id')
            this.form.areaName = _.find(this.provinces, { code: this.form.area }).name
            postQueryDeal(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                     let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  background: rgb(243, 243, 243);
  padding: 0 20px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.reload {
  background-color: rgba(236, 240, 245, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
.formBox {
  border: 1px solid #e4e4e4;
  border-top: 7px solid #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}

.form {
  background-color: #fff;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 20px;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line1 {
  height: 1px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
}
/deep/ .el-input {
  width: 200px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>
